import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Leaf, Package } from 'lucide-react';

function CategoryProductList({
  products = [],
  categoryName = '',
  currentSlug = null,
  sectionTitle = 'Products in this category',
}) {
  const activeRef = useRef(null);

  useEffect(() => {
    if (currentSlug && activeRef.current) {
      activeRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [currentSlug, products.length]);

  if (products.length === 0) {
    return null;
  }

  return (
    <section className="product-range pd-category-range">
      <div className="product-list">
        <div className="section-title reveal">
          <Leaf size={14} strokeWidth={1.75} />
          <h2>{sectionTitle}</h2>
        </div>

        <p className="pd-category-count reveal">
          {products.length} export-grade {categoryName} products — click any item for full details.
        </p>

        {products.map((item, index) => {
          const reverse = index % 2 === 1;
          const isActive = currentSlug === item.slug;

          return (
            <article
              key={item.id}
              ref={isActive ? activeRef : null}
              className={`product-item reveal ${reverse ? 'reverse' : ''} ${isActive ? 'product-item--active' : ''}`}
            >
              <div className="product-item-image">
                <img src={item.image} alt={item.name} loading="lazy" />
                {isActive && <span className="product-item-active-badge">Current product</span>}
              </div>
              <div className="product-item-content">
                <span className="product-item-icon">
                  <Package size={22} strokeWidth={1.5} />
                </span>
                <p className="product-item-meta">
                  {categoryName}
                  {item.hsn ? ` · HSN ${item.hsn}` : ''}
                </p>
                <h3>{item.name}</h3>
                <p>{item.description}</p>
                {isActive ? (
                  <span className="product-item-link product-item-link--static">
                    Viewing this product
                  </span>
                ) : (
                  <Link to={`/products/${item.slug}`} className="product-item-link">
                    View product details
                    <ArrowRight size={14} />
                  </Link>
                )}
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}

export default CategoryProductList;
